import React from 'react';

// Partnership Management - Analytics (User Management CSS)
const AnalyticsTab = () => {
  return (
    <div className="tab-content">
      <p className="partnership-section-subtitle" style={{ marginBottom: 16 }}>
        High-level overview of the Syllera partnership program performance.
      </p>

      <div className="partnership-analytics-grid">
        <div className="partnership-stat-card">
          <h3>Total Partners</h3>
          <p className="partnership-stat-value">0</p>
        </div>
        <div className="partnership-stat-card">
          <h3>Total Referrals</h3>
          <p className="partnership-stat-value">0</p>
        </div>
        <div className="partnership-stat-card">
          <h3>Total Commissions</h3>
          <p className="partnership-stat-value">$0.00</p>
        </div>
        <div className="partnership-stat-card">
          <h3>Monthly Partner Revenue</h3>
          <p className="partnership-stat-value">$0.00</p>
        </div>
      </div>
    </div>
  );
};

export default AnalyticsTab;

